var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
export function Input(_a) {
    var name = _a.name, autoComplete = _a.autoComplete, label = _a.label, _b = _a.isCustomError, isCustomError = _b === void 0 ? false : _b, rest = __rest(_a, ["name", "autoComplete", "label", "isCustomError"]);
    return (_jsx(Controller, { name: name, render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            return (_jsx(TextField, __assign({}, field, { autoComplete: autoComplete || name, "data-testid": "input-".concat(name), error: Boolean(fieldState.error), fullWidth: true, helperText: isCustomError ? undefined : (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, label: label, name: name, variant: "standard" }, rest)));
        } }));
}
